



































import { Component, Prop, Vue } from 'vue-property-decorator';
import BarChart from '@/features/reports/components/chartjs/BarChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '@/features/reports/components/ChartError.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data, Series, SeriesConfig } from '@/features/reports/models';
import shortid from 'shortid';
import { ChartConfig } from '@/features/reports/components/chartjs/chartConfig';

@Component({
	components: {
		BarChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		HelpIcon,
	},
})
export default class ChannelMessagesTrendChart extends Vue {
	@Prop() public data!: Data;

	@Prop() public loadedData!: boolean;

	@Prop() public loadingError!: boolean;

	public reportId = '';

	public tooltipText = 'A trend showing the total sent and received messages for each channel';

	public created() {
		this.reportId = `${shortid.generate()}`;
	}

	public get seriesOrder(): SeriesConfig[] {
		const channels: SeriesConfig[] = [
			{ name: 'BT Smart Messaging Tailored', displayName: 'BT Smart Messaging Tailored', colour: '#5614B4' },
			{ name: 'Google Business Messages', displayName: 'Google Business Messages', colour: '#34A853' },
			{ name: 'GOV.UK Notify SMS', displayName: 'GOV.UK Notify SMS', colour: '#000000' },
			{ name: 'Instagram', displayName: 'Instagram', colour: '#E1306C' },
			{ name: 'Messenger', displayName: 'Messenger', colour: '#006AFF' },
			{ name: 'Twitter', displayName: 'Twitter', colour: '#1DA1F2' },
			{ name: 'Web Assistant', displayName: 'Web Assistant', colour: '#062B80' }
		];

		return channels.filter(c => {
			return this.data.series.some(s => s.name === c.name);
		});
	}

	public get reportData(): Data {
		return {
			scale: this.data.scale,
			series: this.data.series
		};
	}

	public createBlankSeries(name: string, displayName: string): Series {
		return {
			name,
			displayName: displayName || name,
			data: this.data.scale.labels.map(() => 0)
		};
	}

	public get loadedAndNotReturnedData() {
		return this.loadedData && (!this.data || !this.data.series || this.data.series.length === 0);
	}

	public get loadedAndReturnedData() {
		return this.loadedData && this.data && this.data.series && this.data.series.length > 0;
	}
}
